import React from "react";
import PropTypes from "prop-types";
import styles from "components/reports/reports-grid.scss";
import { Grid, AutoSizer, CellMeasurerCache } from "react-virtualized";
import { CellRenderer, getGridHeight } from "components/grid/grid-components";
import { NoReports } from "components/reports/no-reports";
import { reportType } from "custom-prop-types";

export const ReportsGrid = ({ reports }) => (
  <div>
    <h1>Past Reports</h1>
    <div className={ styles["grid-container"] }>
      <AutoSizer disableHeight>
        {({ width }) => (
          <Grid
            cache={ cache }
            cellRenderer={ ({ ...gridProps }) => <CellRenderer { ...gridProps } newKey={ gridProps.key } /> }
            className={ styles.grid }
            columnCount={ columns.length }
            columns={ columns }
            columnWidth={ width / columns.length }
            documents={ reports }
            fixedColumnCount={ 1 }
            fixedRowCount={ 1 }
            height={ getGridHeight(0, reports.length, 45) }
            isRowFocusable={ false }
            isSelectable={ false }
            noContentRenderer={ () => <NoReports totalCount={ reports.length } /> }
            rowCount={ reports.length + 1 }
            rowHeight={ 45 }
            selectedDocumentIds={ [] }
            width={ width }
          />
        )}
      </AutoSizer>
    </div>
  </div>
);

ReportsGrid.propTypes = {
  reports: PropTypes.arrayOf(reportType).isRequired
};

const columns = [
  {
    key: "exported",
    name: "Date",
    visible: true
  },
  {
    key: "name",
    name: "Name",
    visible: true
  },
  {
    key: "to",
    name: "Type",
    visible: true
  },
  {
    key: "url",
    name: "Download",
    visible: true
  }
];

const cache = new CellMeasurerCache({
  defaultWidth: 75,
  minWidth: 75,
  fixedHeight: true
});



// WEBPACK FOOTER //
// ./src/js/components/reports/reports-grid.jsx